import React from 'react';
import { addMilliseconds, format } from 'date-fns';
import { formatInTimeZone, getTimezoneOffset } from 'date-fns-tz';
import { setTimeZone, timeZoneSelector } from 'Features/App/appSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useMatch, useParams } from 'react-router-dom';
import { stationFullSelector } from 'Features/App/Dictionaries/selectors';

export const UTC = { label: '+00:00', value: 'UTC' };
export const STATION_TIME = { value: 'StationTime', label: 'Время по станции' };
export const USER_TIME = { value: 'UserTime', label: 'Часовой пояс пользователя' };

export const TimeZonesList = {
  '+0': { value: '+00:00', label: '' },
  '+1': { value: '+01:00', label: '' },
  '+2': { value: '+02:00', label: '' },
  '+3': { value: '+03:00', label: '' },
  '+4': { value: '+04:00', label: '' },
  '+5': { value: '+05:00', label: '' },
  '+6': { value: '+06:00', label: '' },
  '+7': { value: '+07:00', label: '' },
  '+8': { value: '+08:00', label: '' },
  '+9': { value: '+09:00', label: '' },
  '+10': { value: '+10:00', label: '' },
  '+11': { value: '+11:00', label: '' },
  '+12': { value: '+12:00', label: '' },
};

export function UTCtoTimeZone(inputDate, zone = '+00:00', dateFormat) {
  return formatInTimeZone(`${inputDate}Z`, zone, dateFormat ?? 'dd.MM.yyyy HH:mm');
}

export function timeZoneToUTC(inputDate, zone = '+00:00', dateFormat) {
  return format(new Date(addMilliseconds(new Date(inputDate), -getTimezoneOffset(zone, inputDate))), dateFormat ?? 'dd.MM.yyyy HH:mm');
}

export function useFormatTimeZone() {
  const urlParams = useMatch('/stations/:stationId/*');
  const { stationId } = urlParams?.params || {};
  const path = useParams();
  const dispatch = useDispatch();

  const selectedZone = useSelector(timeZoneSelector);

  const station = useSelector(stationFullSelector(parseInt(stationId, 10)));

  const isStations = React.useMemo(() => path['*'].includes('stations/'), [path]);
  const isGlobal = React.useMemo(() => path['*'].includes('/'), [path]);

  const title = React.useMemo(() => {
    if (isGlobal) return 'selectedUserTimeZone';
    if (isStations) return 'stations';
    return null;
  }, [isGlobal, isStations]);

  React.useEffect(() => {
    if (isGlobal) {
      if (selectedZone.selectedUserTimeZone === USER_TIME.value) {
        dispatch(setTimeZone({ name: 'selectedUserTimeZone', value: formatInTimeZone(new Date(), Intl.DateTimeFormat().resolvedOptions().timeZone, 'XXX') }));
      } else {
        dispatch(setTimeZone({ name: 'selectedUserTimeZone', value: '+00:00' }));
      }
    }
  }, [dispatch, isGlobal, selectedZone.selectedUserTimeZone]);

  React.useEffect(() => { // TODO пока не удаляю ничего, тк еще потребуется
    if (isStations && station) {
      if (selectedZone.selectedStations === STATION_TIME.value) {
        dispatch(setTimeZone({ name: 'stations', value: station?.station.timeZone ? convertNumToTime(station?.station.timeZone) : '+00:00' })); // чтобы не сломать алгоритм, если не будет зоны у станции, поставил UTC
      } else if (selectedZone.selectedStations === USER_TIME.value) {
        dispatch(setTimeZone({ name: 'stations', value: formatInTimeZone(new Date(), Intl.DateTimeFormat().resolvedOptions().timeZone, 'XXX') }));
      } else {
        dispatch(setTimeZone({ name: 'stations', value: '+00:00' }));
      }
    }
  }, [dispatch, isStations, path, selectedZone.selectedStations, station]);

  return {
    isStations,
    isGlobal,
  };
}

// https://speedysense.com/convert-float-to-time-in-javascript/
export function convertNumToTime(number) {
  // Check sign of given number
  let sign = (number >= 0) ? 1 : -1;

  // Set positive value of number of sign negative
  number *= sign;

  // Separate the int from the decimal part
  let hour = Math.floor(number);
  let decpart = number - hour;

  const min = 1 / 60;
  // Round to nearest minute
  decpart = min * Math.round(decpart / min);

  let minute = `${Math.floor(decpart * 60)}`;

  // Add padding if need
  if (minute.length < 2) {
    minute = `0${minute}`;
  }
  if (hour.toString().length < 2) {
    hour = `0${hour}`;
  }

  // Add Sign in final result
  sign = sign === 1 ? '+' : '-';
  // Concate hours and minutes
  const time = `${sign + hour}:${minute}`;
  return time;
}
